import React, {useRef, useEffect,useState} from "react";

import {
    stopRecording,
    startRecording
} from "./misc";

const RecordingButton = ({onStart, onResult, disabled, title= "🎙"}) => {

    const isRecordingRef = useRef(false);
    const [isRecording,setIsRecording] = useState(false);

    const myOnResult = (text) => {
        myStopRecording();
        onResult(text);
    }

    const myStartRecording = () => {
        onStart();
        if (isRecordingRef.current) {
            myStopRecording();
            return;
        }
        isRecordingRef.current = true;
        startRecording({
            onResult: myOnResult,
            onStart: () => {
                isRecordingRef.current = true;
                setIsRecording(true);
            },
            onEnd: () => {
                isRecordingRef.current = false;
                setIsRecording(false);
            }
        });
    }

    const myStopRecording = () => {
        stopRecording();
                setIsRecording(false);

                isRecordingRef.current = false;
    }


    // ✅ Gestion des raccourcis clavier (barre d'espace) pour enregistrer la voix !
    useEffect(() => {
        if (disabled) return;
        const handleKeyDown = (event) => {
            if (event.code === 'Space' && !isRecordingRef) {
                event.preventDefault(); // Pour éviter le scroll page
                myStartRecording()
            }
        };
        const handleKeyUp = (event) => {
            if (event.code === 'Space') {
                event.preventDefault();
                myStopRecording();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [isRecordingRef, disabled]);

    return (
        <button className={"button-secondary audio-btn "+ (isRecording ? "recording" : "")}
                            onPointerDown={() => myStartRecording()}
                            onContextMenu={(e) => e.preventDefault()}
                disabled={disabled}
                    >
            {title}️
                    </button>
    )

}

export default RecordingButton;